import TopBar from '@/pages/home/components/TopBar';
import HeroSection from '@/pages/home/components/HeroSection';
import HeadlineSection from '@/pages/home/components/HeadlineSection';
import EvidenceSection from '@/pages/home/components/EvidenceSection';
import FlashTimeline from '@/pages/home/components/FlashTimeline';
import HotRanking from '@/pages/home/components/HotRanking';
import GallerySection from '@/pages/home/components/GallerySection';
import CommentSection from '@/pages/home/components/CommentSection';
import CategoryZones from '@/pages/home/components/CategoryZones';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <TopBar />
      <main className="w-full">
        <HeroSection />
        <HeadlineSection />
        <EvidenceSection />
        <FlashTimeline />
        <HotRanking />
        <GallerySection />
        <CommentSection />
        <CategoryZones />
      </main>
      <Footer />
    </div>
  );
}